import type { FilterIds } from '~/types/FilterIds'
import type { FilterDefinition } from '~/utils/serviceSearch/types/FilterDefinition'
import { generateServiceFilterDeliveryFormatsObjects } from '~/utils/serviceSearch/types/ServiceFilterDeliveryFormats'
export const useSelectedDeliveryFormats = () => {
  const { filters } = useServiceSearchStore()
  const deliveryFormats = generateServiceFilterDeliveryFormatsObjects()

  const selectedDeliveryFormats = computed<FilterDefinition<FilterIds>[]>(() => {
    return Object.values(deliveryFormats)
      .filter((format) => filters.deliveryFormats.includes(format.key))
      .map((format) => {
        const filter: FilterDefinition<FilterIds> = {
          ...format,
          unselect: () => {
            filters.deliveryFormats = filters.deliveryFormats.filter((p) => p !== format.key)
          }
        }

        return filter
      })
  })

  return { selectedDeliveryFormats }
}
